export default function SkeletonFazenda() {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl p-5 border border-gray-100 dark:border-gray-700 animate-pulse">
      <div className="flex items-start justify-between mb-4">
        <div><div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-full w-40 mb-2" /><div className="h-3 bg-gray-100 dark:bg-gray-700 rounded-full w-28" /></div>
        <div className="w-8 h-8 bg-gray-100 dark:bg-gray-700 rounded-xl" />
      </div>
      <div className="h-2 bg-gray-100 dark:bg-gray-700 rounded-full mb-4" />
      <div className="grid grid-cols-4 gap-2">{[...Array(4)].map((_, i) => <div key={i} className="h-12 bg-gray-100 dark:bg-gray-700 rounded-xl" />)}</div>
    </div>
  );
}
